import { render, staticRenderFns } from "./ProfilLive.vue?vue&type=template&id=2ca09eda&"
import script from "./ProfilLive.vue?vue&type=script&lang=js&"
export * from "./ProfilLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports